import { render, staticRenderFns } from "./medic_systemic.vue?vue&type=template&id=caeb6270"
import script from "./medic_systemic.vue?vue&type=script&lang=js"
export * from "./medic_systemic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports